// Modules
import React from 'react';
import _ from 'lodash';

import { FormCard } from 'components/content-containers/cards';
import { PageContent } from 'components/page';
import SVG from 'components/widgets/icons/svg';
import WorkOrderForm from 'components/models/company/work-order-form';
import appHistory from 'app-history';
import WorkOrder from 'services/data/work-order';

import * as actions from '../store/actions';


export default function WatchEdit({ routeParams: { workOrderId }, id: companyId }) {
  const { data: company } = actions.useCompany(companyId);
  const { data: workOrders, refetch } = actions.useCompanyWorkOrders(companyId);
  const workOrder = _.find(workOrders, { id: Number(workOrderId) });

  const onSubmit = values => {
    const update = _.clone(values);

    return WorkOrder.update(update)
      .then(() => refetch())
      .then(() => {
        appHistory.push(`/companies/${company.id}/work-orders`);
      });
  };

  const initialValues = _.pick(workOrder, ['company', 'number', 'description', 'estimatedHours', 'id']);

  if (!workOrder) return null;

  return (
    <PageContent className="bg-medium-blue-grey">
      <div className="form-summary flex flex-equal-children">
        <FormCard className="form-form">
          <div className="form-header">
            <SVG src="svg/invoice-list.svg" className="work-order" />
            <h5 className="form-title">Edit Work Order</h5>
          </div>
          <WorkOrderForm
            initialValues={initialValues}
            onSubmit={onSubmit}
          />
        </FormCard>
      </div>
    </PageContent>
  );
}
